"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SLOT_MODAL = void 0;
exports.SLOT_MODAL = Object.freeze({
    ROLE_LIST: "#slot-modal-roles-component"
});
